/*****************
 2019-2-13, AJK, created file
******************/

/* global localStorage*/
import axios from 'axios'
import store from '../store.js'


export default {
    login: function(username, pass, hash, cb) {
        cb = arguments[arguments.length - 1]
        authenticate(username, pass, hash, (response) => {
            if (response.authenticated) {
                if (cb) cb(response)
            } else {
                if (cb) cb(response)
            }
        })
    },

    getToken: function() {
        return localStorage.sessionId;
    },

    logout: function(cb) {
        delete localStorage.sessionId;
        store.commit('setUserData', {})
        store.commit('setCampaigns', {})
        store.commit('setEmails', {})
        store.commit('setCampaignsAndEmails', {})
        store.commit('setSelectedCampaign', {})
        if (cb) cb()
    },

    loggedIn: function() {
        return store.state.userInfo.loggedIn
    },
    
    passwordUpdated: function(){
        return !store.state.userInfo.isPasswordChangeNeeded
    }

}
 

function authenticate(username, pass, hash, cb) {
    
    var credentials = `{
        "username" : "${username}",
        "password" : "${pass}",
        "hash" : "${hash}"
    }`
    axios.post(`login.php`, credentials)
        .then(response => {
            // success callback
            var expirationDate = new Date();
            expirationDate.setMinutes(expirationDate.getMinutes() + 10);
            response.data.expirationDate = expirationDate;
            if (response.data.loggedIn === true) {
                cb({
                    authenticated: true,
                    user: response.data
                })
            } else {
                cb({
                    authenticated: false,
                    errorMsg: response.data.message
                })
            }
        }, error => {
            // error callback
            console.log(error);
            cb({
                authenticated: false,
                errorMsg: 'Service not available, try again later please.',
                error: error
            })
        });
}